import { usePunditUserContext } from "@circle-react/contexts";

export const useLiveStreamsFeatureFlags = () => {
  const { currentCommunitySettings, isLoading } = usePunditUserContext();

  return {
    isLoading,
    isLiveStreamsLimitsEnabled:
      !!currentCommunitySettings?.live_streams_limits_enabled,
    isLiveMobileWebRTCEnabled:
      !!currentCommunitySettings?.live_mobile_webrtc_enabled,
    isLargeLiveStreamsEnabled:
      !!currentCommunitySettings?.large_live_streams_enabled,
    isLivePipEnabled: !!currentCommunitySettings?.live_pip_enabled,
  };
};
